<script>
import FlagIcon from '../../Icon/FlagIcon.vue'

export default {
  components: { FlagIcon },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    locales: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getLocalizedLanguageName(locale) {
      return new Intl.DisplayNames([locale], { type: 'language' }).of(locale)
    },
  },
}
</script>
<template>
  <div class="dropdown-menu dropdown-menu-right">
    <div class="ml-3 mt-2">{{ $t('menu.language') }}</div>
    <a
      v-for="locale in locales"
      :key="locale"
      :class="{ 'dropdown-item': true, active: modelValue === locale }"
      @click="$emit('update:modelValue', locale)"
    >
      <FlagIcon :locale="locale" />
      <span class="ml-1 capitalize">{{ getLocalizedLanguageName(locale) }}</span>
    </a>
  </div>
</template>
